import React from 'react';
const BaseErrorPage = ({ msg, title, action, subTitle }) => (React.createElement(React.Fragment, null,
    typeof title === 'string' ? (React.createElement("h1", { className: "align-middle" }, title)) : (title),
    subTitle ? subTitle : null,
    React.createElement("p", { className: "text-center" }, msg),
    action));
export default BaseErrorPage;
